import React, { memo, useCallback, useContext } from 'react';
import { Heading, Flex, Box } from '@chakra-ui/react';
import { Switch } from 'components';
import { Accordion, AccordionBody, AccordionHeader } from '../Accordion';
import { IRoles } from 'types/roles';
import { RolesCtx } from '../..';

export const RolesComponent: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const ctx = useContext(RolesCtx);

  const getRoleIndex = useCallback((roles: IRoles[], groupIndex: number, roleIndex: number) => {
    if (groupIndex > 0) {
      const nRoles = roles.slice(0, groupIndex);
      let index = 0;
      for (const role of nRoles) {
        index += role.roles.length;
      }
      return roleIndex + index;
    } else return roleIndex;
  }, []);

  return (
    <Box>
      {ctx.roles.map((item, groupIndex) => (
        <Accordion
          key={item.name}
          mb="1em"
          border="1px solid"
          borderColor="brand.gray100"
          borderRadius={7}
        >
          <AccordionHeader height="50px" border="1px solid blue">
            <Heading
              fontSize="18px"
              fontWeight="bold"
              padding="1rem"
              color="brand.black700"
            >{`Menu "${item.name}"`}</Heading>
          </AccordionHeader>

          <AccordionBody paddingInline={'1rem'}>
            <Flex paddingBottom="1rem" width="100%" direction="column">
              {item.roles
                // .sort((a, b) => {
                //   return a.description < b.description ? -1 : a.name > b.name ? 1 : 0;
                // }) // organizando por ordem alfabética
                .map((role, roleIndex) => (
                  <Flex
                    key={role.name}
                    width="100%"
                    p="12px 1rem"
                    borderRadius="4px"
                    bgColor="brand.gray"
                    marginY="5px"
                    background={'#F2F5F8'}
                  >
                    <Switch
                      disabled={disabled}
                      name={`roles[${getRoleIndex(ctx.roles, groupIndex, roleIndex)}]`}
                      label={role.description}
                      value={{ id: role.id, name: role.name }}
                    />
                  </Flex>
                ))}
            </Flex>
          </AccordionBody>
        </Accordion>
      ))}
    </Box>
  );
};
export const AccordionRoles = memo(RolesComponent);
